<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetItemList' }">预算项目</el-breadcrumb-item>
                <el-breadcrumb-item>预算项目{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details_temp2023">
                        <el-form-item label="预算科目：" prop="budget_subject_name">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.budget_subject_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入预算科目名称搜索"
                                :remote-method="remoteBudgetMethod"
                                :loading="budgetLoading"
                                size="mini"
                                clearable
                                @change="budgetChange"
                                value-key="rid"
                                :disabled="contorlDisabled"
                            >
                                <el-option v-for="item in budgetOptions" :key="item.rid" :label="item.name" :value="item"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="年：" prop="period">
                            <el-date-picker
                                v-model="ruleForm.period"
                                type="year"
                                placeholder="请选择年"
                                format="yyyy年"
                                value-format="yyyy"
                                :disabled="contorlDisabled"
                                clearable
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="分布类型：" prop="distribution_type">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.distribution_type"
                                placeholder="请选择分布类型"
                                size="mini"
                                clearable
                                @change="distributionChange"
                            >
                                <el-option v-for="item in distributionOptions" :key="item.rid" :label="item.name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="结转余额：" prop="carry_balance">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.carry_balance"
                                placeholder="请选择结转余额"
                                size="mini"
                                clearable
                            >
                                <el-option v-for="item in carryOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="预算：" prop="budget">
                            <el-input
                                size="mini"
                                v-model.trim="ruleForm.budget"
                                placeholder="请输入预算"
                                clearable
                                @keyup.native="ruleForm.budget = oninput(ruleForm.budget, 1)"
                                :disabled="contorlDisabled"
                            />
                        </el-form-item>
                        <el-form-item label="是否控制预算：" prop="control">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.control"
                                placeholder="请选择是否控制预算"
                                size="mini"
                                clearable
                                filterable
                            >
                                <el-option v-for="item in controlOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="预算标准：" prop="budget_standard">
                            <el-input
                                size="mini"
                                v-model.trim="ruleForm.budget_standard"
                                placeholder="请输入预算标准"
                                clearable
                                @keyup.native="ruleForm.budget_standard = oninput(ruleForm.budget_standard, 1)"
                            />
                        </el-form-item>
                        <el-form-item label="控制范围：" prop="control_scope">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.control_scope"
                                placeholder="请选择控制范围"
                                size="mini"
                                clearable
                                filterable
                            >
                                <el-option v-for="item in controlScopeOptions" :key="item.value" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分布差率：" prop="distribution_difference_ratio" v-if="distributionType == 4">
                            <el-input
                                size="mini"
                                v-model.trim="ruleForm.distribution_difference_ratio"
                                placeholder="请输入分布差率"
                                clearable
                                @keyup.native="ruleForm.distribution_difference_ratio = oninput(ruleForm.distribution_difference_ratio, 2)"
                            />
                        </el-form-item>
                        <el-form-item label="负责人：" prop="principal_rid">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.principal_rid"
                                placeholder="请选择负责人"
                                size="mini"
                                clearable
                                filterable
                            >
                                <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="部门：" prop="department_rid">
                            <el-select
                                clearable
                                filterable
                                v-model="ruleForm.department_rid"
                                placeholder="部门会根据预算科目自动切换"
                                class="btn"
                                size="mini"
                                disabled
                            >
                                <el-option
                                    v-for="item in departmentOptions"
                                    :key="item.rid"
                                    :label="item.name + '-' + item.code"
                                    :value="item.rid"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="项目：" prop="project_rid" v-if="assistanceType == 4">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.project_rid"
                                filterable
                                placeholder="请选择项目"
                                size="mini"
                                clearable
                                :disabled="contorlDisabled"
                            >
                                <el-option v-for="item in projectOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="受益人：" prop="beneficiary_rid" v-if="assistanceType == 2">
                            <el-select
                                style="width: 100%"
                                filterable
                                v-model="ruleForm.beneficiary_rid"
                                placeholder="请选择受益人"
                                size="mini"
                                clearable
                                :disabled="contorlDisabled"
                            >
                                <el-option v-for="item in beneficiaryOptions" :key="item.rid" :label="item.name" :value="item.rid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="供应商：" prop="supplier_rid" v-if="assistanceType == 5">
                            <vSearchSelect
                                model_key="supplier_rid"
                                model_name="请输入供应商搜索"
                                request_uri="searchAccounts"
                                default_option_key="supplier_option"
                                :default_option="ruleForm['supplier_option']"
                                @onDropChange="onDropChange"
                                ref="supplier_ref"
                                :is_disabled="contorlDisabled"
                            ></vSearchSelect>
                        </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }}
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'budgetItemEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(v) {
                    return v.getYear() < new Date().getYear();
                }
            },
            btnLoading: false,
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            contorlDisabled: false,
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {},
            rules: {
                budget_subject_name: [{ required: true, message: '请选择预算科目', trigger: 'blur' }],
                period: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                project_rid: [{ required: true, message: '请选择项目', trigger: 'blur' }],
                distribution_type: [{ required: true, message: '请选择分布类型', trigger: 'blur' }],
                carry_balance: [{ required: true, message: '请选择结转余额', trigger: 'blur' }],
                budget: [{ required: true, message: '请输入预算', trigger: 'blur' }],
                control: [{ required: true, message: '请选择是否控制预算', trigger: 'blur' }],
                department_rid: [{ required: true, message: '请选择部门', trigger: 'blur' }],
                control_scope: [{ required: true, message: '请选择控制范围', trigger: 'blur' }],
                principal_rid: [{ required: true, message: '请选择负责人', trigger: 'blur' }],
                beneficiary_rid: [{ required: true, message: '请选择受益人', trigger: 'blur' }],
                supplier_rid: [{ required: true, message: '请选择供应商', trigger: 'blur' }]
            },
            btnTitle: '',
            budgetLoading: false,
            budgetOptions: [],
            projectOptions: [],
            beneficiaryOptions: [],
            principalOptions: [],
            departmentOptions: [],
            controlScopeOptions: [],
            controlOptions: [
                {
                    name: '是',
                    rid: 1
                },
                {
                    name: '否',
                    rid: 2
                }
            ],
            distributionOptions: [
                {
                    name: '末期 ',
                    rid: 2
                },
                {
                    name: '近期',
                    rid: 3
                },
                {
                    name: '线性',
                    rid: 4
                }
            ],
            carryOptions: [
                {
                    name: '结转',
                    rid: 1
                },
                {
                    name: '不结转 ',
                    rid: 2
                }
            ],
            assistanceType: '',
            distributionType: '',
            date: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
        this.date = new Date().getFullYear();
    },
    mounted() {
        this.getProject(); //项目下拉
        this.getPrincipal(); //获取受益人下拉
        this.remoteDepartment(); //部门下拉方法
        this.getControl();
        if (this.type == 3 || this.type == 5) {
            this.contorlDisabled = false;
            this.ruleForm.period = this.date.toString();
        } else {
            this.contorlDisabled = true;
        }
        if (this.type == 1 || this.type == 5) {
            this.$nextTick(() => {
                this.getDetails(); //获取详情
            });
        } else {
            this.ruleForm = {
                budget_subject_rid: '',
                period: '',
                project_rid: '',
                beneficiary_rid: '',
                supplier_rid: '',
                distribution_type: 4,
                carry_balance: 2,
                budget: '',
                control: 1,
                distribution_difference_ratio: 0,
                budget_standard: '',
                department_rid: '',
                control_scope: 1,
                principal_rid: '',
                supplier_option: { rid: '', name: '' }
            };
            this.ruleForm.period = this.date.toString();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.ruleForm[key] = value;
        },
        //控制范围下拉
        getControl() {
            let params = {};
            this.$api
                .dropdownControlScope(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.controlScopeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        oninput(value, type) {
            let str = value;
            let len1 = str.substr(0, 1);
            let len2 = str.substr(1, 1);
            //如果第一位是0，第二位不是点，就用数字把点替换掉
            if (str.length > 1 && len1 == 0 && len2 != '.') {
                str = str.substr(1, 1);
            }
            //第一位不能是.
            if (len1 == '.') {
                str = '';
            }
            if (len1 == '+') {
                str = '';
            }
            if (len1 == '-') {
                str = '';
            }

            //限制只能输入一个小数点
            if (str.indexOf('.') != -1) {
                let str_ = str.substr(str.indexOf('.') + 1);
                if (str_.indexOf('.') != -1) {
                    str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1);
                }
            }
            //正则替换
            str = str.replace(/[^\d^\.]+/g, ''); // 保留数字和小数点
            if (type == 1) {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1'); // 小数点后只能输 2 位
            } else {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,4})?.*$/, '$1'); // 小数点后只能输 4 位
            }

            return str;
        },
        //分布类型改变
        distributionChange(val) {
            this.distributionType = val;
        },
        //部门下拉方法
        remoteDepartment() {
            let params = {};
            this.$api
                .budgetDepartment(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.departmentOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取受益人下拉
        getPrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.beneficiaryOptions = res.data;
                        this.principalOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //预算科目改变
        budgetChange(val) {
            this.ruleForm.budget_subject_name = val.name;
            this.ruleForm.budget_subject_rid = val.rid;
            this.assistanceType = val.assistance;
            this.ruleForm.department_rid = val.department_rid;
            this.ruleForm.principal_rid = val.principal_rid;
        },
        //项目下拉
        getProject() {
            let params = {};
            this.$api
                .dropdownProjects(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.projectOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //预算科目远程搜索方法
        remoteBudgetMethod(query) {
            if (query !== '') {
                this.budgetLoading = true;
                let params = {
                    key: query
                };
                this.$api
                    .searchBudgetSubject(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.budgetLoading = false;
                                this.budgetOptions = res.data;
                            }, 200);
                        } else {
                            this.budgetOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.budgetLoading = false;
                this.budgetOptions = [];
            }
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetItemList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetItemDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        // 先临时这样处理下，这个代码写的太垃圾了，不想动
                        setTimeout(() => {
                            this.ruleForm = res.data;
                            this.ruleForm.period = '20' + res.data.period;
                            this.ruleForm.supplier_option = { rid: res.data.supplier_rid, name: res.data.supplier_name };
                        }, 500);

                        this.distributionType = res.data.distribution_type;
                        this.assistanceType = res.data.budget_subject.assistance;
                    }
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            this.ruleForm.budget = this.ruleForm.budget ? this.ruleForm.budget : 0;
            this.ruleForm.rid = this.rid;
            this.$api
                .budgetItemUpdate(this.ruleForm)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            this.ruleForm.budget = this.ruleForm.budget ? this.ruleForm.budget : 0;
            this.$api
                .budgetItemInsert(this.ruleForm)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>